<template>
    <section class="bg-white py-10 relative overflow-hidden xl:px-20 lg:px-14 md:px-14 px-8 font-poppins antialiased">
  <div class="flex flex-col-reverse md:flex-row lg:flex-col xl:flex-row items-center justify-between gap-6 md:gap-10">
    <!-- Bagian Kiri (Teks + Features) -->
    <div class="w-full md:w-1/2 text-start">
      <div class="flex items-center justify-start mb-6">
        <div class="h-7 w-1 bg-[#186a85] opacity-80 rounded-lg"></div>
        <span class="px-2 py-2 text-[#186a85] text-md tracking-wider">Our Services</span>
      </div>
      <h2 class="text-gray-600 text-2xl font-medium mb-3 leading-tight">
        Comprehensive IT Solutions for Your Business
      </h2>
      <p class="text-gray-500 text-sm">
        We provide tailored technology services to help your business thrive.
      </p>
    </div>
  </div>
  <div class="flex flex-col md:flex-col lg:flex-row xl:flex-row items-center justify-center gap-10">
  <!-- Bagian Kiri (Daftar Fitur) -->
  <div class="grid grid-cols-1 gap-2 pt-10 w-full ">
    <div
      v-for="(feature, index) in features"
      :key="index"
      class="flex flex-col items-start p-4 bg-white border-2 border-gray-100 shadow-lg rounded-lg cursor-pointer transform hover:scale-105 hover:bg-gray-50 transition-all duration-300">
      <h3 class="text-[#007E98] text-lg font-medium mb-1">{{ feature.title }}</h3>
      <p class="text-gray-600 text-sm">{{ feature.description }}</p>
    </div>
  </div>

  <!-- Bagian Kanan (Gambar) -->
  <div class="w-full md:w-1/2 flex justify-center items-center xl:pt-10">
    <img src="@/assets/Img.svg" alt="IT Solutions" class="max-w-xl w-full md:w-auto">
  </div>
</div>

</section>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      features: [
        { title: 'Custom Software Development', description: 'Tailored software for your business need.' },
        { title: 'IT Consulting & Systems Integration', description: 'End-to-end strategy & implementation.' },
        { title: 'Cloud-Based Solutions', description: 'Secure and scalable cloud service.' },
        { title: 'Mobile and Web App Development', description: 'Build user-friendly applications.' },
        { title: 'Business Automation', description: 'AI, machine learning, and digital transformation.' },
      ]
    };
  }
};
</script>

<style>
@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-100% / 2)); }
}

.animate-scroll {
  animation: scroll 80s linear infinite;
}

.animate-scroll:hover {
  animation-play-state: paused;
}
</style>